import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  config: {
    initialColorMode: 'light',
    useSystemColorMode: true,
  },
  colors: {
    // Primary brand colors
    brand: {
      50: '#E6F6FF',
      100: '#BAE3FF',
      200: '#7CC4FA',
      300: '#47A3F3',
      400: '#2186EB',
      500: '#0967D2', // Primary brand color
      600: '#0552B5',
      700: '#03449E',
      800: '#01337D',
      900: '#002159',
    },
    // Secondary colors
    secondary: {
      50: '#F0FFF4',
      100: '#C6F6D5',
      200: '#9AE6B4',
      300: '#68D391',
      400: '#48BB78',
      500: '#38A169', // Secondary brand color
      600: '#2F855A',
      700: '#276749',
      800: '#22543D',
      900: '#1C4532',
    },
    // Accent colors
    accent: {
      50: '#FDF2F8',
      100: '#FCE7F3',
      200: '#FBCFE8',
      300: '#F9A8D4',
      400: '#F472B6',
      500: '#EC4899', // Accent color
      600: '#DB2777',
      700: '#BE185D',
      800: '#9D174D',
      900: '#831843',
    },
    // Neutral colors
    neutral: {
      50: '#F7FAFC',
      100: '#EDF2F7',
      200: '#E2E8F0',
      300: '#CBD5E0',
      400: '#A0AEC0',
      500: '#718096',
      600: '#4A5568',
      700: '#2D3748',
      800: '#1A202C',
      900: '#171923',
    },
    // Success colors
    success: {
      50: '#F0FFF4',
      100: '#C6F6D5',
      200: '#9AE6B4',
      300: '#68D391',
      400: '#48BB78',
      500: '#38A169',
      600: '#2F855A',
      700: '#276749',
      800: '#22543D',
      900: '#1C4532',
    },
    // Error colors
    error: {
      50: '#FFF5F5',
      100: '#FED7D7',
      200: '#FEB2B2',
      300: '#FC8181',
      400: '#F56565',
      500: '#E53E3E',
      600: '#C53030',
      700: '#9B2C2C',
      800: '#822727',
      900: '#63171B',
    },
    // Warning colors
    warning: {
      50: '#FFFAF0',
      100: '#FEEBC8',
      200: '#FBD38D',
      300: '#F6AD55',
      400: '#ED8936',
      500: '#DD6B20',
      600: '#C05621',
      700: '#9C4221',
      800: '#7B341E',
      900: '#652B19',
    },
  },
  fonts: {
    heading: 'Poppins, sans-serif',
    body: 'Open Sans, sans-serif',
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: 'bold',
        borderRadius: 'md',
      },
      variants: {
        solid: (props) => ({
          bg: props.colorMode === 'dark' ? 'brand.500' : 'brand.500',
          color: 'white',
          _hover: {
            bg: props.colorMode === 'dark' ? 'brand.600' : 'brand.600',
          },
        }),
        secondary: (props) => ({
          bg: props.colorMode === 'dark' ? 'secondary.500' : 'secondary.500',
          color: 'white',
          _hover: {
            bg: props.colorMode === 'dark' ? 'secondary.600' : 'secondary.600',
          },
        }),
        accent: (props) => ({
          bg: props.colorMode === 'dark' ? 'accent.500' : 'accent.500',
          color: 'white',
          _hover: {
            bg: props.colorMode === 'dark' ? 'accent.600' : 'accent.600',
          },
        }),
      },
    },
    Link: {
      baseStyle: {
        _hover: {
          textDecoration: 'none',
        },
      },
    },
    Heading: {
      baseStyle: {
        color: 'brand.500',
      },
    },
  },
  styles: {
    global: (props) => ({
      body: {
        bg: props.colorMode === 'dark' ? 'neutral.800' : 'neutral.50',
        color: props.colorMode === 'dark' ? 'neutral.100' : 'neutral.800',
      },
      h1: {
        color: props.colorMode === 'dark' ? 'brand.300' : 'brand.600',
      },
      h2: {
        color: props.colorMode === 'dark' ? 'brand.300' : 'brand.600',
      },
      h3: {
        color: props.colorMode === 'dark' ? 'brand.300' : 'brand.600',
      },
      a: {
        color: props.colorMode === 'dark' ? 'brand.300' : 'brand.500',
        _hover: {
          color: props.colorMode === 'dark' ? 'brand.200' : 'brand.600',
        },
      },
    }),
  },
});

export default theme; 